import React from 'react';

import { Box, Chip, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { CancelIcon } from '../../icons';

import { oneRowTagsStyles, tagStyles } from './AutocompleteCDS.styles';
import { getOptionLabel as getOptionLabelUtil } from './AutocompleteCDS.utils';

const tooltipClasses = { tooltip: 'max-w-640 text-12' };

const AutocompleteCDSTags = ({
  tagValue,
  getTagProps,
  optionName,
  size,
  disablePortalProp,
  withTooltip,
  getChipProps,
  getOptionLabel,
  name = '',
  isOneRow = false,
}) => {
  const content = (
    <>
      {tagValue.map((option, index) => {
        const tagProps = getTagProps({ index });
        const label = getOptionLabel?.(option) ?? getOptionLabelUtil({ option, key: optionName });
        const chipProps = getChipProps?.(option, tagProps) || tagProps;

        const chipMarkup = (
          <Chip
            {...chipProps}
            deleteIcon={<CancelIcon data-fieldname={name} data-index={index} size={IconSize[16]} />}
            key={tagProps.key}
            label={label}
            size={size}
            sx={tagStyles}
          />
        );

        return withTooltip ? (
          <Tooltip
            PopperProps={disablePortalProp}
            classes={tooltipClasses}
            key={tagProps.key}
            title={label}
          >
            {chipMarkup}
          </Tooltip>
        ) : (
          chipMarkup
        );
      })}
    </>
  );

  if (isOneRow) {
    return <Box sx={oneRowTagsStyles}>{content}</Box>;
  }

  return content;
};

AutocompleteCDSTags.propTypes = {
  disablePortalProp: PropTypes.object.isRequired,
  getTagProps: PropTypes.func.isRequired,
  optionName: PropTypes.string.isRequired,
  tagValue: PropTypes.array.isRequired,
  withTooltip: PropTypes.bool.isRequired,
  getChipProps: PropTypes.func,
  getOptionLabel: PropTypes.func,
  size: PropTypes.string,
  name: PropTypes.string,
  isOneRow: PropTypes.bool,
};

export default AutocompleteCDSTags;
